module.exports = __webpack_public_path__ + "media/images/office_icon@3x-50b72f0d.png";